module.exports = __webpack_public_path__ + "static/img/dynamicm.fa0987d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicm.png
// module id = LBUW
// module chunks = 45